import { Carousel } from 'antd';
import styled from 'styled-components';

export const CarouselStyled = styled(Carousel)`
	margin-bottom: 24px;
	width: 100%;
	.slick-list {
		border-radius: 10px;
	}
`;

export const CarouselItemStyled = styled(`div`)`
	aspect-ratio: 1817 / 1160;
	background-size: cover;
	color: #fff;
	font-size: 20px;
`;
